import type { Key } from "react"

import type { GroupByType } from "../types/chart-types"
import type { TableColumnDefinition } from "./tableWidgetData"

const GROUP_BY_COLUMN_KEY: Record<string, string> = {
  agent: "run_agent_id",
  mutation: "mutation_id",
  test_set: "test_set_id",
  persona: "persona_id",
  template: "run_template_name",
  assignee: "assignee",
}

export const getDefaultTableSortColumn = ({
  groupBy,
  groupByMetadataKey,
  metricIds,
}: {
  groupBy?: GroupByType
  groupByMetadataKey?: string
  metricIds: string[]
}): string =>
  groupByMetadataKey
    ? "metadataValue"
    : groupBy
      ? GROUP_BY_COLUMN_KEY[groupBy] || "count"
      : metricIds.length <= 1
        ? "count"
        : metricIds[0] || "count"

export const resolveTableSortColumn = ({
  columns,
  fallbackColumn,
  requestedColumn,
}: {
  columns: TableColumnDefinition[]
  fallbackColumn: string
  requestedColumn: Key
}): string =>
  columns.some((column) => column.key === requestedColumn)
    ? String(requestedColumn)
    : fallbackColumn
